import { Button } from '@hivebrite/design-system/Button';

import { getItemArguments } from 'hb-builder/components/BuilderComponents/block/Partners/utils/getItemArguments';
import {
  useBuilderContext,
  useComponentsContext,
  useBuilderConfigContext,
} from 'hb-builder/hooks';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import type { PartnersGrid } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

const AddPartnerButton = ({ item: partners }: { item: PartnersGrid }) => {
  const { addItem, getPath } = useBuilderContext();
  const { components } = useComponentsContext();
  const { features } = useBuilderConfigContext();

  const { Partner } = components;

  const addPartner = () => {
    if (!partners.children) {
      return null;
    }

    const newPartner = createNewItem(
      Partner.item({
        ...getItemArguments({
          component: Partner,
          features,
          template: partners.children[0].template,
        }),
        index: partners.children.length,
      }),
    );

    addItem({
      direction: partners.children.length + 1,
      id: partners.id,
      item: newPartner,
      path: getPath(partners.id),
    });
  };

  if ((partners.children?.length || 0) > 7) {
    return null;
  }

  return (
    <Button
      fontFamily="Inter"
      m="10px 20px"
      onClick={addPartner}
      variant="primary"
    >
      {__('Add a logo')}
    </Button>
  );
};

export default AddPartnerButton;
